import { render, staticRenderFns } from "./info_banner.vue?vue&type=template&id=a769a028"
import script from "./info_banner.vue?vue&type=script&lang=js"
export * from "./info_banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports